import { Card, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Select from "react-select";

function Summary(props) {
  const [count, setCount] = useState(props.count);
  const [summary, setSummary] = useState(props);
  const [orderBy, setOrderBy] = useState("")


  const sort_list = [
    { value: "StartDate-asc", label: "Start Date(Older first)" },
    { value: "StartDate-desc", label: "Start Date(Latest first)" },
    { value: "EndDate-asc", label: "End Date(Older first)" },
    { value: "EndDate-desc", label: "End Date(Latest first)" },
    { value: "UserCount-asc", label: "Attendees(min-max)" },
    { value: "UserCount-desc", label: "Attendees(max-min)" },
    { value: "Title-asc", label: "Title(A-Z)"},
    { value: "Title-desc", label: "Title(Z-A)"},
    { value: "StatusId-asc",label:"Training status(open first)"},
    { value: "StatusId-desc",label:"Training status(complete first)"}
  ]

  useEffect(() => {
    sort_list.map((value)=>{
      if(value.value === "StatusId-asc"){
        var sort = [];
        sort.push(value);
        setOrderBy(sort)
      }
    })
  },[])
  useEffect(() => {
    if (props.count !== undefined) {
      setCount(props.count);
    }
  }, [props.count]);
  useEffect(() => {
    if (props.summary !== undefined) {
      setSummary(props.summary);
    }
  }, [props.summary]);

  const handleSort = (selected) => {
    var value = selected.value;
    var order = value.split("-")[0];
    var direction = value.split("-")[1];
    props.handleArrow(order,direction)
    var sort = [];
    sort.push(selected);
    setOrderBy(sort);
  }

  return (
    <div className="training-count">
      <Grid container spacing={2}>        
        <Grid item xs={2}>
          <div class="badge-status completed">
            <small class="badge-label">Completed</small>
            <p class="status-count stensil">{summary.completed && summary.completed > 0?summary.completed:0}</p>
          </div>
        </Grid>
        <Grid item xs={2}>
           <div class="badge-status ongoing">
            <small class="badge-label">OnGoing</small>
            <p class="status-count stensil">{summary.onGoing && summary.onGoing > 0?summary.onGoing:0}</p>
          </div>
        </Grid>
        <Grid item xs={2}>
          <div class="badge-status open">
            <small class="badge-label">Open</small>
            <p class="status-count stensil">{summary.open && summary.open > 0?summary.open:0}</p>
          </div>
        </Grid>
        <Grid item xs={2}>
          <div class="badge-status scheduled">
            <small class="badge-label">Scheduled</small>
            <p class="status-count stensil">{summary.scheduled && summary.scheduled > 0?summary.scheduled:0}</p>
          </div>
        </Grid>
        {/* <Grid item xs={1}></Grid> */}
        {/* <Grid item xs={2}>
        <div class="badge-status stensil">
            <small class="badge-label status-count">You have got {count} training</small>
            <br/>
            <p class="status-count" style={{display:"none"}}>count</p>
          </div>
        </Grid> */}
        <Grid item xs={4} className="sort-byfilter">
        <div className="badge-margin">
        {/* <span>Sort by</span> */}
            <Select placeholder={<div>Sort by</div>}
            options ={sort_list}
            value = {orderBy}
            onChange={handleSort}
            />
        </div>
        {/* <p style={{paddingLeft:"30px",paddingTop:"10px"}}>{orderByDirection === "asc"?<ArrowUpwardIcon fontSize='small' onClick={()=>handleSort("desc")}/>:<ArrowDownwardIcon fontSize='small' onClick={()=>handleSort("asc")}/>}</p> */}
        </Grid>
      </Grid>
    </div>
  );
}
export default Summary;
